<script>
import SortableTable from "@components/SortableTable.vue";
import api from "@services/api";

export default {
  extends: SortableTable,
  components: {},
  props: {},
  data: () => ({
    dataCadastro: null
  }),
  computed: {},
  created() {},
  methods: {
    inserirData(){
      let formData = new FormData();
      formData.append("dataCadastro", this.dataCadastro);
      if(this.dataCadastro != null){
        api.post(`crud/Expediente/inserirDataFechamento`,formData).then(() => {
          this.$emit("RecarregarTable");
        });
      }
      
    }
  },
  watch: {
    dataCadastro: function(){
      // console.log(this.dataCadastro);
    }
  }
};
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-form @submit.prevent="inserirData">
          <div class="row">

            <div class="col-3">
              <b-form-datepicker  v-model="dataCadastro" class="mb-2"></b-form-datepicker>
            </div>          
           <div class="col-4">
              <b-button
                class="btn"
                variant="primary"
                type="submit"          
                >Cadastrar Data
              </b-button> 
           </div>
          </div>     
        </b-form>
      </div>
    </div>
    
  </div>
</template>
